import { useCallback, useState } from "react";

function clone(value) {
  if (value === undefined || value === null) return value;

  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }

  return JSON.parse(JSON.stringify(value));
}

export default function useEditorHistory({
  nodes,
  setNodes,
  projectParameters,
  setProjectParameters,
  onAfterRestore,
}) {
  const [history, setHistory] = useState([]);
  const [future, setFuture] = useState([]);

  const snapshot = useCallback(() => {
    return {
      nodes: clone(nodes),
      projectParameters: clone(projectParameters),
    };
  }, [nodes, projectParameters]);

  const applyProjectChange = useCallback(
    (mutator) => {
      setHistory((prev) => [...prev, snapshot()]);
      setFuture([]);

      mutator?.();
    },
    [snapshot]
  );

  const undo = useCallback(() => {
    setHistory((prev) => {
      if (!prev.length) return prev;

      const last = prev[prev.length - 1];

      setFuture((f) => [snapshot(), ...f]);

      setNodes(clone(last.nodes));
      setProjectParameters(clone(last.projectParameters));
      onAfterRestore?.();

      return prev.slice(0, -1);
    });
  }, [snapshot, setNodes, setProjectParameters, onAfterRestore]);

  const redo = useCallback(() => {
    setFuture((prev) => {
      if (!prev.length) return prev;

      const next = prev[0];

      setHistory((h) => [...h, snapshot()]);

      setNodes(clone(next.nodes));
      setProjectParameters(clone(next.projectParameters));
      onAfterRestore?.();

      return prev.slice(1);
    });
  }, [snapshot, setNodes, setProjectParameters, onAfterRestore]);

  const clearHistory = useCallback(() => {
    setHistory([]);
    setFuture([]);
  }, []);

  return {
    history,
    future,
    applyProjectChange,
    undo,
    redo,
    clearHistory,
  };
}